import { render, staticRenderFns } from "./SocialMediaView.vue?vue&type=template&id=2acd2b7a&scoped=true"
import script from "./SocialMediaView.vue?vue&type=script&lang=js"
export * from "./SocialMediaView.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaView.vue?vue&type=style&index=0&id=2acd2b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd2b7a",
  null
  
)

export default component.exports